import { defineStore } from 'pinia'
import { features } from '@/libs/api'

export const FEATURES = {
  CARD: 'CARD',
  APPLE_WALLET_CONNECT: 'APPLE_WALLET_CONNECT',
  TOP_UP_FROM_CARD: 'WALLET_TOP_UP_FROM_CARD',
  TOP_UP_FROM_APPLE: 'WALLET_TOP_UP_FROM_APPLE',
  ECNG_BUY_USDT: 'ECNG_BUY_USDT',
  ECNG_SELL_USDT: 'ECNG_SELL_USDT',
  VERIFICATION_OF_PAYEE: 'VERIFICATION_OF_PAYEE',

  // Settings personal data flags
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  CHANGE_PHONE: 'CHANGE_PHONE',

  MULTILANGUAGE: 'MULTILANGUAGE',
  TRANSFER_TO_CARD: 'TRANSFER_TO_CARD',
  WALLET_TOP_UP_FROM_OPENBANKING: 'WALLET_TOP_UP_FROM_OPENBANKING',
}

export const useFeatures = defineStore('features', {
  state: () => ({
    features: [],
  }),
  actions: {
    /**
     * Load list of available settings
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    async getFeatures() {
      let list = Object.values(FEATURES)
      const { data } = await features.getFeatures(list)
      this.features = data

      if (window.location.hostname !== 'app.finsei.com') {
        if (!this.features.includes(FEATURES.MULTILANGUAGE)) {
          this.features.push(FEATURES.MULTILANGUAGE)
        }
      }
    },
  },
  getters: {
    hasFeature(state) {
      return (feature) => state.features.includes(feature)
    },
  },
})
